import React from "react";
import { Box, Button, Flex, Heading, Text, Badge, useColorModeValue } from "@chakra-ui/react";
import { CiCalendar, CiLocationOn, CiUser, CiCoins1, CiRollingSuitcase  } from "react-icons/ci";
import { FaRegFilePdf } from "react-icons/fa";

interface MissionCardProps {
    mission: {
        id: string;
        opportunite: string;
        publicationDate: string;
        compte: string;
        domaine: string;
        metier: string;
        experience: string | null;
        localisation: string;
        manager: string;
        description: string;
    };
    onPostuler: (missionId: string) => void;
}

const MissionCard: React.FC<MissionCardProps> = ({ mission, onPostuler }) => {
    const cardBg = useColorModeValue('white', 'gray.800');
    const accentColor = "#420073";
    const hoverShadow = useColorModeValue('lg', 'dark-lg');

    return (
        <Box
            p={5}
            mb={6}
            borderWidth="1px"
            borderRadius="lg"
            bg={cardBg}
            shadow="md"
            _hover={{
                shadow: hoverShadow,
                transform: 'translateY(-2px)',
            }}
            transition="all 0.2s"
        >
            <Heading fontSize="xl" mb={3} color={accentColor}>
                {mission.opportunite}
            </Heading>

            <Flex direction="column" gap={2}>
                <Flex align="center">
                    <CiCoins1 size={18} color={accentColor} />
                    <Text ml={2} fontSize="sm">{mission.compte}</Text>
                </Flex>

                <Flex align="center">
                    <CiRollingSuitcase  size={18} color={accentColor} />
                    <Text ml={2} fontSize="sm">{mission.metier}</Text>
                    <Badge ml={2} colorScheme="purple">{mission.domaine}</Badge>
                </Flex>

                <Flex align="center">
                    <CiLocationOn size={18} color={accentColor} />
                    <Text ml={2} fontSize="sm">{mission.localisation}</Text>
                </Flex>

                <Flex align="center">
                    <CiUser size={18} color={accentColor} />
                    <Text ml={2} fontSize="sm">{mission.manager}</Text>
                </Flex>

                <Flex align="center" justify="space-between" mt={3}>
                    <Flex align="center">
                        <CiCalendar size={18} color={accentColor} />
                        <Text ml={2} fontSize="xs">
                            Publié le {new Date(mission.publicationDate).toLocaleDateString("fr-FR")}
                        </Text>
                    </Flex>

                    <Button
                        colorScheme="purple"
                        size="sm"
                        leftIcon={<FaRegFilePdf />}
                        onClick={() => onPostuler(mission.id)}
                        bg={accentColor}
                    >
                        Postuler
                    </Button>
                </Flex>
            </Flex>
        </Box>
    );
};

export default MissionCard;